import { AuthData } from './authdata';

export class UserModel {
  id: any;
    userName: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    status: string | undefined;
    email: string | undefined;
    role: string | undefined;
   
 
    ipAddress: string | undefined;
    landingPage: string | undefined;
   
    authData: AuthData | undefined;
  }
